import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { ResourceList } from "../../../components/Resource";
import { useParams } from "react-router-dom";

export interface IResourceListPage {}

export const ResourceListPage: FC<IResourceListPage> = () => {
  const { resourceName } = useParams();
  
  return (
    <AuthenticatedLayout
      pageTitle={`${
        resourceName === "T5_Recipient" ? "T5 Recipient" : resourceName === "T3_Beneficiary" ? "T3 Beneficiary" : resourceName
      } List`}
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        {
          text: `${
            resourceName === "T5_Recipient" ? "T5 Recipient" : resourceName === "T3_Beneficiary" ? "T3 Beneficiary" : resourceName
          }`,
          navigateTo: `/resources/${resourceName}`,
        },
      ]}
      mainContents={<ResourceList />}
    />
  );
};
